<img _ngcontent-pge-c105="" src="../../../assets/images/myvista-logo-white.png" alt="logo" class="hoverLogo">
<div class="iwg-form-dialog" [ngClass]="{'iwg-dialog-half-size': (selectedStepIndex == 4)}">
    <div class="md-toolbar-tools d-flex md-theme m-0 p-3">
        <h2 class="m-0 toolbartitle">
            Get a Quote
        </h2>
        <span class="flex"></span>
        <span *ngIf="selectedStepIndex <= 3">Step {{selectedStepIndex + 1}} of {{maxSteps - 1}}</span>
        <span *ngIf="selectedStepIndex > 3">Review & Submit</span>
    </div>

    <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
    <mat-dialog-content style="overflow: hidden;padding:0px;display: table;width: 100%;">
        <div class="vista-popup-height">
            <div class="d-flex layout-row" style="height: 100%;">
                <div class="d-flex layout-column flex md-padding w-100"
                     style="height:100%;overflow-y: scroll;box-sizing: border-box;padding: 16px;">
                    <mat-tab-group [(selectedIndex)]="selectedStepIndex" class="header-less-tabs">
                        <mat-tab label="Step 1">                            
                            <form name="quoteStep1" #quoteStep1="ngForm"> 
                                <h3>Service and Location</h3>
                                <div class="md-input-container">
                                    <div class="mat-form-withtooltip">
                                        <mat-label>Service</mat-label>
                                        <mat-select [(ngModel)]="step1.service_type_id" name="step1.service_type_id"
                                        #steponeservice_type_id="ngModel" (selectionChange)="OnChangeServiceType()" 
                                        [disabled]="true">
                                        <mat-option [value]="1" *ngIf="step1.include_EOR">
                                            Employer of Record
                                        </mat-option>
                                        <mat-option [value]="3" *ngIf="step1.include_Compliance">
                                            Compliance
                                        </mat-option>
                                        <mat-option [value]="2" *ngIf="step1.include_AOR">
                                            Agent of Record
                                        </mat-option>
                                    </mat-select>
                                    </div>                                   
                                     <mat-icon
                                            [matTooltip]="'<b>Employer of Record: </b>Request an employer for the worker(s). <p /><b>Compliance: </b>Request evaluation of indepedent contractor engagement. <p /><b>Agent of Record: </b>Request invoice and payment services for an independent contractor.'"
                                            matTooltipPosition="above"
                                            class="ng-scope md-iwgNavbar-theme material-icons">help
                                    </mat-icon>
                                    <mat-error *ngIf="!steponeservice_type_id.valid && steponeservice_type_id.touched">Required
                                    </mat-error>
                                </div>
                                <div class="md-input-container">
                                    <div class="mat-form-withtooltip">
                                        <mat-label>Quote Title</mat-label>
                                        <input matInput [(ngModel)]="step1.title" maxlength="200" #Ctitle="ngModel" 
                                        name="title" required>
                                    </div>
                                    <mat-icon [matTooltip]="'Provide a title with enough context to help you track it.'"
                                              matTooltipPosition="above"
                                              class="ng-scope md-iwgNavbar-theme material-icons">help
                                    </mat-icon>
                                    <mat-error *ngIf="!Ctitle.valid && Ctitle.touched">Required</mat-error>
                                </div>

                                <app-end-client-select name="endclients" [(ngModel)]="step1.selectedEndClient"
                                                       [preselected-item-id] ="step1.selectedEndClient?step1.selectedEndClient.ID:null"
                                                       [refresh-on-preselect]="true" *ngIf="allowEndClients">
                                </app-end-client-select>

                                <app-add-end-clients
                                        [new-item-id]="step1.selectedEndClient?step1.selectedEndClient.ID:null"
                                        *ngIf="allowEndClients">
                                </app-add-end-clients>

                                <app-team-select *ngIf="allowTeams" [(ngModel)]="step1.selectedTeam"
                                                 name="selectedTeams1"
                                                 [preselected-item-id]="step1.selectedTeam?step1.selectedTeam.ID:null"
                                                 [filter-item-id-NOT]="Filter_ClientID">
                                </app-team-select>

                               
                                <div class="md-input-container">
                                    <app-country-select name="selectedCountry" 
                                    (countryChange)="getCountryRegionCode($event.Abbreviation, step1.selectedState?.Abbreviation)"
                                    [(ngModel)]="step1.selectedCountry"  [alltext]="'All'"    
                                    [helptext]="''" [preselectedItemId]="step1.selectedCountry?step1.selectedCountry.ID:null"                                    
                                        [labeltext]="'Country'" [isRequired]='true'>
                                        <mat-icon class="ng-scope md-iwgNavbar-theme material-icons"
                                        matToolTip="Select the country in which the work will be performed."
                                        matTooltipPosition="above">
                                        help
                                    </mat-icon>
                                    </app-country-select>
                                </div>
                                <app-state-select name="selectedState" [required]="true"
                                [(ngModel)]="step1.selectedState"
                                [preselected-item-id]="step1.selectedState?step1.selectedState.ID:null"
                                [country-id]="step1.selectedCountry?step1.selectedCountry.ID:null"
                                [alltext]="'Please Select'" *ngIf="showRegions" [isDisabled]="false" [labeltext]="Region"
                                [helptext]="'Select the region or state in which the work will be performed.'">
              </app-state-select>                              

                                <div layout *ngIf="step1.service_type_id == 1">
                                    <div class="mat-form-withtooltip">
                                        <mat-label>City</mat-label>
                                        <input matInput [(ngModel)]="step1.city" maxlength="250" name="city" #city="ngModel">
                                        <mat-icon
                                                [matTooltip]="'Provide the name of the city in which the work will be performed.'"
                                                matTooltipPosition="above"
                                                class="ng-scope md-iwgNavbar-theme material-icons">help
                                        </mat-icon>
                                        <mat-error *ngIf="!city.valid && city.touched">Invalid</mat-error>
                                    </div>
                                </div>
                            </form>
                        </mat-tab>
                        <mat-tab label="step 2">
                            <form ngcloak name="quoteStep2" (ngSubmit)="quoteStep1.valid" novalidate #quoteStep2="ngForm">
                                <mat-card-content class="iwg-md-padding">
                                    <h3>Basic Information</h3>                                   
                                     <div class="md-input-container">
                                                <div class="mat-form-withtooltip">
                                            <mat-label>Number of Workers</mat-label>
                                            <input matInput type="number" min="1" step="1" [step]="1"
                                                   [(ngModel)]="step2.number_of_workers"
                                                   name="number_of_workers"
                                                   #number_of_workers="ngModel"
                                                   required>
                                                </div>
                                            <mat-icon>
                                                help
                                                <mat-tooltip-component md-direction="top">
                                                    How many workers are expected to provide services?
                                                </mat-tooltip-component>
                                            </mat-icon>
                                            <mat-error
                                                    *ngIf="!number_of_workers.valid && number_of_workers.touched">
                                                Required
                                            </mat-error>                                        
                                    </div>

                                    <div class="md-input-container" layout *ngIf="step1.service_type_id == 1"
                                    fxLayout="row"  fxLayoutAlign="start">
                                    <div class="matradiobtn" fxLayout="column" fxLayoutAlign="start start">
                                            <mat-label>Business Entity in Country</mat-label>
                                            <mat-radio-group [(ngModel)]="step2.is_entity_in_country" 
                                            name="is_entity_in_countryr" class="d-block" aria-label="Select an option"
                                            #is_entity_in_country="ngModel" required>
                                                <mat-radio-button [value]="true">Yes</mat-radio-button>
                                                <mat-radio-button [value]="false">No</mat-radio-button>
                                            </mat-radio-group>
                                            <input type="text" [(ngModel)]="step2.is_entity_in_country"
                                                    name="is_entity_in_country" style="display: none;" required>
                                            <mat-icon>
                                                help
                                                <mat-tooltip-component md-direction="top">
                                                    Has your company established a business entity in this country? This
                                                    may impact pricing and services.
                                                </mat-tooltip-component>
                                            </mat-icon>
                                            <mat-error
                                                    *ngIf="!is_entity_in_country.valid && is_entity_in_country.touched">
                                                Required
                                            </mat-error>

                                        </div>
                                    </div>
                                    <div class="md-input-container" layout *ngIf="step1.service_type_id == 1"
                                    fxLayout="row" fxLayoutAlign="start">
                                    <div class="matradiobtn" fxLayout="column" fxLayoutAlign="start start">
                                            <mat-label>Worker Residence</mat-label>
                                            <mat-radio-group [(ngModel)]="step2.is_expat" name="is_expatr" aria-label="Select an option" #is_expat="ngModel"
                                             required>
                                                <mat-radio-button [value]="false">Local</mat-radio-button>
                                                <mat-radio-button [value]="true">Expatriate</mat-radio-button>
                                            </mat-radio-group>
                                            <input type="text" [(ngModel)]="step2.is_expat" name="is_expat" required style="display: none;">
                                            <mat-icon matTooltip="If the worker is a citizen of the country in which services will be provided, select 'Local.' If not, select 'Expatriate.'
                                            " matTooltipPosition="above">
                                                help
                                            </mat-icon>
                                            <mat-error *ngIf="!is_expat.valid && is_expat.touched">
                                                Required
                                            </mat-error>

                                        </div>
                                    </div>
                                   
                                        <app-country-select layout="row" 
                                                            [preselectedItemId]="step2.expat_nationality?.ID"
                                                            *ngIf="step1.service_type_id == 1 && step2.is_expat==true"
                                                            alltext="'Please Select'"
                                                            labeltext="'Country of Citizenship'" showAllCountries="true"
                                                            is-required="true">
                                            <mat-icon
                                                    matTooltip="  Please select the country of citizenship for the worker."
                                                    matTooltipPosition="above">
                                                help
                                            </mat-icon>
                                        </app-country-select>
                                   
                                    <div class="md-input-container" layout
                                         *ngIf="step1.service_type_id == 1 && step2.is_expat==true" fxLayout="row"
                                         fxLayoutAlign="start">
                                         <div class="matradiobtn" fxLayout="column" fxLayoutAlign="start start">
                                            <mat-label>Visa / Work Permit Required</mat-label>
                                            <mat-radio-group [(ngModel)]="step2.is_expat_visa_required" #is_expat_visa_required="ngModel"
                                            name="is_expat_visa_required" class="d-block"  aria-label="Select an option">
                                                <mat-radio-button [value]="true">Yes</mat-radio-button>
                                                <mat-radio-button [value]="false">No</mat-radio-button>
                                            </mat-radio-group>
                                            <input type="text" [(ngModel)]="step2.is_expat_visa_required"                                                   
                                                   name="is_expat_visa_required" required style="display: none;">
                                            <mat-icon matTooltip="  Does the worker need a visa?"
                                                      matTooltipPosition="above">
                                                help
                                            </mat-icon>
                                            <mat-error
                                                    *ngIf="!is_expat_visa_required.valid && is_expat_visa_required.touched">
                                                Required
                                            </mat-error>
                                        </div>
                                    </div>
                                    <div class="md-input-container" fxLayout="row"
                                    fxLayoutAlign="start"   *ngIf="step1.service_type_id == 1 && step2.is_expat==true">
                                    <div class="matradiobtn" fxLayout="column" fxLayoutAlign="start start">
                                            <mat-label>Worker is in Country</mat-label>
                                            <mat-radio-group [(ngModel)]="step2.is_worker_in_country" name="is_worker_in_countryr"  #is_worker_in_country="ngModel"
                                            class="d-block"  aria-label="Select an option">
                                                <mat-radio-button [value]="true">Yes</mat-radio-button>
                                                <mat-radio-button [value]="false">No</mat-radio-button>
                                            </mat-radio-group>
                                            <input type="text" [(ngModel)]="step2.is_worker_in_country"                                                   
                                                   name="is_worker_in_country" required style="display: none;">
                                            <mat-icon matTooltip="   Is the worker in country now?"
                                                      matTooltipPosition="above">
                                                help
                                            </mat-icon>
                                            <mat-error
                                                    *ngIf="!is_worker_in_country.valid && is_worker_in_country.touched">
                                                Required
                                            </mat-error>

                                        </div>
                                    </div>

                                </mat-card-content>
                            </form>

                        </mat-tab>
                        <mat-tab label="step 3">
                            <form ng-cloak name="quoteStep3" (ngSubmit)="quoteStep1.valid" novalidate #quoteStep3="ngForm">
                                  <h3>Nature of Work</h3>
                                    <div class="md-input-container">
                                        <div class="mat-form-withtooltip">                                       
                                            <mat-label>Job Title</mat-label>
                                            <input matInput [(ngModel)]="step3.job_title" ng-maxlength="200" name="job_title"
                                                   #job_title="ngModel"
                                                   required>
                                        </div>
                                            <mat-icon matTooltip="Please provide a job title that reflects the specific duties. Examples: Sales for Paris, Lead Software Enginner, Admin to CEO, etc.
                                             " matTooltipPosition="above">
                                                help
                                            </mat-icon>
                                            <mat-error *ngIf="!job_title.valid && job_title.touched">
                                                Required
                                            </mat-error>                                       
                                    </div>
                                    <div class="md-input-container" fxLayout="row"
                                    fxLayoutAlign="start" *ngIf="step1.service_type_id == 1">
                                    <div class="matradiobtn" fxLayout="column" fxLayoutAlign="start start">
                                            <mat-label>Travel Required</mat-label>
                                            <mat-radio-group [(ngModel)]="step3.is_travel_required" name="is_travel_requiredr" layout="row">
                                                <mat-radio-button [value]="true">Yes</mat-radio-button>
                                                <mat-radio-button [value]="false">No</mat-radio-button>
                                            </mat-radio-group>
                                            <input [(ngModel)]="step3.is_travel_required" name="is_travel_required"
                                               #is_travel_required="ngModel" style="display: none;"
                                                   required>
                                                </div>
                                                <div fxFlexAlign="baseline">
                                            <mat-icon matTooltip="   Please designate if the engagement requires travel, whether that be in country or abroad.
                                               " matTooltipPosition="above">
                                                help
                                            </mat-icon>
                                            <mat-error
                                                    *ngIf="!is_travel_required.valid && is_travel_required.touched">
                                                Required
                                            </mat-error>
                                        </div>                                      
                                    </div>
                                    <div class="md-input-container" *ngIf="step1.service_type_id == 1">
                                        <div class="mat-form-withtooltip">
                                            <mat-label>Job Description (Enter Text or Upload File)</mat-label>
                                            <textarea matInput [(ngModel)]="step3.job_description" rows="5" #job_description="ngModel"
                                                name="job_descriptionta" md-select-on-focus required></textarea>
                                        </div>
                                        <mat-icon matTooltip="A complete job description is necessary to properly classify the assignment in country. If you have a job description as a document, please upload it, below. We support documents of the following format: doc, docx, pdf, txt, and rtf.
                                                                                  " matTooltipPosition="above">
                                            help
                                        </mat-icon>
                                        <mat-error *ngIf="!job_description.valid && job_description.touched">
                                            Required
                                        </mat-error>
                                    </div>
                                    <app-file-upload upload-url="/Api/Quotes/{{existingQuoteId}}"
                                                     file-property="job_description_file"
                                                     uploaded-file-name="{{step3.job_description_file}}"
                                                     *ngIf="step1.service_type_id == 1"></app-file-upload>
                               
                            </form>
                        </mat-tab>
                        <mat-tab label="step 4">
                            <form name="quoteStep4" (ngSubmit)="quoteStep4.valid" novalidate #quoteStep4="ngForm">                               
                                    <h3>Time and Compensation</h3>
                                    <div  class="md-input-container">                                       
                                            <mat-label>Start Date</mat-label>
                                            <input name="start_date" #start_date="ngModel"
                                                   [(ngModel)]="step4.start_date"
                                                   placeholder="Select" matInput [matDatepicker]="picker1" required>
                                            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                            <mat-datepicker #picker1></mat-datepicker>
                                            <mat-icon
                                                    matTooltip="Please specify the date on which the engagement will start."
                                                    matTooltipPosition="above">
                                                help
                                            </mat-icon>                                       
                                    </div>
                                    <div class="md-input-container">
                                        <div class="mat-form-withtooltip">
                                        <mat-label>Typical Weekly Hours</mat-label>
                                        <input matInput type="number" min="0.01" [(ngModel)]="step4.weekly_hours"
                                               #weekly_hours="ngModel"
                                               name="weekly_hours"
                                               required>
                                        </div>
                                        <mat-icon matTooltip=" Please specify the average number of hours each week the worker will provide services to your company.
                                          " matTooltipPosition="above">
                                            help
                                        </mat-icon>
                                        <mat-error *ngIf="!weekly_hours.valid && weekly_hours.touched">
                                            Required
                                        </mat-error>
                                    </div>
                                    <p layout class="iwg-form-label iwg-help-box">
                                        <span flex>Length of Project</span>
                                        <mat-icon matTooltip=" How long do you expect the worker(s) to provide services to your company? If you are unsure or there is no specified end date, please select 'Project Length Indefinite'.
                                          " matTooltipPosition="above">
                                            help
                                        </mat-icon>
                                    </p>
                                    <div>
                                        <div class="md-input-container" fxFlex="25">
                                            <div class="mat-form-withtooltip">
                                                <mat-label>Years</mat-label>
                                                <input matInput name="years" [(ngModel)]="step4.project_length_years" type="number" min="0"
                                                    #project_length_years="ngModel" [required]="!step4.is_project_length_indefinite"
                                                    [disabled]="step4.is_project_length_indefinite" (change)="OnChangeDuration('years')">
                                                <mat-error *ngIf="!project_length_years.valid && project_length_years.touched">
                                                    Required
                                                </mat-error>
                                            </div>
                                        </div>
                                        <div class="md-input-container" fxFlex="25">
                                            <mat-form-field class="mat-form-withtooltip">
                                                <mat-label>Months</mat-label>
                                                <input matInput name="months" [(ngModel)]="step4.project_length_months" type="number" min="0"
                                                    #project_length_months="ngModel" [required]="!step4.is_project_length_indefinite"
                                                    [disabled]="step4.is_project_length_indefinite" (change)="OnChangeDuration('months')">
                                                <mat-error *ngIf="!project_length_months.valid && project_length_months.touched">
                                                    Required
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <div class="md-input-container" fxFlex="25">
                                            <mat-form-field class="mat-form-withtooltip">
                                                <mat-label>Weeks</mat-label>
                                                <input matInput name="weeks" [(ngModel)]="step4.project_length_weeks" type="number" min="0"
                                                    #project_length_weeks="ngModel" [required]="!step4.is_project_length_indefinite"
                                                    [disabled]="step4.is_project_length_indefinite" (change)="OnChangeDuration('weeks')">
                                                <mat-error *ngIf="!project_length_weeks.valid && project_length_weeks.touched">
                                                    Required
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <div class="md-input-container" fxFlex="25">
                                            <mat-checkbox class="example-margin" [(ngModel)]="step4.is_project_length_indefinite"
                                                name="is_project_length_indefinitecb" (change)="OnChangeDuration('indefinite')">
                                                Indefinite
                                            </mat-checkbox>
                                        </div>
                                    </div>
                                    <p layout class="iwg-form-label iwg-help-box">
                                        <span flex>Pay</span>
                                        <mat-icon matTooltip=" How much do you expect to pay the worker(s)?
                                        . " matTooltipPosition="above">
                                            help
                                        </mat-icon>
                                    </p>
                                    <div>
                                        <div class="md-input-container" fxFlex="30">
                                            <div class="mat-form-withtooltip">
                                                <mat-label>Amount</mat-label>
                                                <input matInput [(ngModel)]="step4.pay_rate" type="number" min="0.01" name="pay_rate" #pay_rate="ngModel"
                                                    required>
                                                <mat-error *ngIf="!pay_rate.valid && pay_rate.touched">
                                                    Required
                                                </mat-error>
                                            </div>
                                        </div>
                                        <div class="md-input-container" fxFlex="30">
                                            <app-currency-select [(ngModel)]="step4.selectedCurrency" name="currencys" [helptext]=""
                                                [preselected-item-id]="step4.selectedCurrency?step4.selectedCurrency.ID:null">
                                            </app-currency-select>
                                        </div>
                                        <div class="md-input-container" style="display: flex;" fxFlex="30"></div>
                                        <app-pay-rate-select [(ngModel)]="step4.selectedPayRateType" name="payrateSel" [helptext]="''">
                                        </app-pay-rate-select>
                                    </div>
                                   
                                    <div class="md-input-container" fxLayout="row" fxLayoutAlign="start">
                                        <div class="matradiobtn" fxLayout="column" fxLayoutAlign="start start">
                                            <mat-label>Commissions Authorized</mat-label>
                                            <mat-radio-group [(ngModel)]="step4.is_commission_authorized" name="is_commission_authorizedr" layout="row">
                                                <mat-radio-button [value]="true">Yes</mat-radio-button>
                                                <mat-radio-button [value]="false">No</mat-radio-button>
                                            </mat-radio-group>
                                            <input type="text" [(ngModel)]="step4.is_commission_authorized" #is_commission_authorized="ngModel"
                                                style="display: none;" name="is_commission_authorized" required>
                                            <mat-icon matTooltip="Will the worker have the opportunity to earn commissions as part of this engagement?
                                                                            . " matTooltipPosition="above">
                                                help
                                            </mat-icon>
                                            <mat-error *ngIf="!is_commission_authorized.valid && is_commission_authorized.touched">
                                                Required
                                            </mat-error>
                                        </div>
                                    </div>
                                    <div class="md-input-container" fxLayout="row" fxLayoutAlign="start">
                                        <div class="matradiobtn" fxLayout="column" fxLayoutAlign="start start">
                                            <mat-label>Bonuses Authorized</mat-label>
                                            <mat-radio-group [(ngModel)]="step4.is_bonus_authorized" name="is_bonus_authorizedr" layout="row">
                                                <mat-radio-button [value]="true">Yes</mat-radio-button>
                                                <mat-radio-button [value]="false">No</mat-radio-button>
                                            </mat-radio-group>
                                            <input type="text" [(ngModel)]="step4.is_bonus_authorized"
                                                   #is_bonus_authorized="ngModel" style="display: none;"
                                                   name="is_bonus_authorized" required>
                                            <mat-icon matTooltip="Will the worker have the opportunity to earn bonuses as part of this engagement?
                                            " matTooltipPosition="above">
                                                help
                                            </mat-icon>
                                            <mat-error
                                                    *ngIf="!is_bonus_authorized.valid && is_bonus_authorized.touched">
                                                Required
                                            </mat-error>
                                        </div>
                                    </div>
                                    <div class="md-input-container">
                                        <div class="mat-form-withtooltip">
                                            <mat-label>Compensation Details &mdash; Bonuses, Commissions, Etc.</mat-label>
                                            <textarea matInput [(ngModel)]="step4.other_compensation" maxlength="1000"
                                                      name="other_compensation" rows="5"
                                                      md-select-on-focus></textarea>
                                            <mat-icon matTooltip="  Please provide details regarding commissiones, bonuses, and other forms of compensation for this engagement. Please include financial amounts, conditions, and timing.
                                             " matTooltipPosition="above">
                                                help
                                            </mat-icon>
                                        </div>
                                    </div>
                                    <div class="md-input-container">
                                        <div class="mat-form-withtooltip">
                                            <mat-label>Additional Notes</mat-label>
                                            <textarea matInput [(ngModel)]="step4.client_notes" name="client_notes" name="client_notestan"
                                                rows="3"></textarea>
                                        </div>
                                    </div>
                            </form>
                        </mat-tab>
                        <mat-tab label="review">                           
                                <h3>Review Quote Details</h3>
                                <div>
                                    <div class="iwg-review-bar" layout="row" layout-align="start center">
                                        <span class="iwg-review-bar-title">Step 1: Service and Location</span><span
                                            flex></span>
                                        <a (click)="selectedStepIndex = 0" class="iwg-review-bar-edit">Edit</a>
                                    </div>
                                    <div class="iwg-widget-box-card">
                                        <label class="iwg-regular-label">Service</label>
                                        <p class="iwg-regular-value">{{step1.selectedServiceName}}</p>
                                    </div>
                                    <div class="iwg-widget-box-card">
                                        <label class="iwg-regular-label">Quote Title</label>
                                        <p class="iwg-regular-value">{{step1.title}}</p>
                                    </div>
                                    <div class="iwg-widget-box-card" *ngIf="allowEndClients">
                                        <label class="iwg-regular-label">End Client</label>
                                        <p class="iwg-regular-value">{{step1.selectedEndClient?.Name}}</p>
                                    </div>
                                    <div class="iwg-widget-box-card" *ngIf="allowTeams">
                                        <label class="iwg-regular-label">Team</label>
                                        <p class="iwg-regular-value">{{step1.selectedTeam?.Name}}</p>
                                    </div>
                                    <div class="iwg-widget-box-card">
                                        <label class="iwg-regular-label">Country</label>
                                        <p class="iwg-regular-value">{{step1.selectedCountry?.Name}}</p>
                                    </div>
                                    <div class="iwg-widget-box-card"
                                         *ngIf="step1.selectedState && step1.service_type_id != 2">
                                        <label class="iwg-regular-label">Region</label>
                                        <p class="iwg-regular-value">{{step1.selectedState?.Name}}</p>
                                    </div>
                                    <div class="iwg-widget-box-card" *ngIf="step1.service_type_id == 1">
                                        <label class="iwg-regular-label">City</label>
                                        <p class="iwg-regular-value">{{step1.city}}</p>
                                    </div>
                                </div>
                                <div *ngIf="step1.service_type_id == 1">
                                    <div class="iwg-review-bar" layout="row" layout-align="start center">
                                        <span class="iwg-review-bar-title">Step 2: Basic Information</span><span
                                            flex></span>
                                        <a (click)="selectedStepIndex = 1" class="iwg-review-bar-edit">Edit</a>
                                    </div>
                                    <div class="iwg-widget-box-card" *ngIf="step1.service_type_id == 1">
                                        <label class="iwg-regular-label">Business Entity in Country</label>
                                        <p class="iwg-regular-value">{{step2.is_entity_in_country | yesNo}}</p>
                                    </div>
                                    <div class="iwg-widget-box-card">
                                        <label class="iwg-regular-label">Number of Workers</label>
                                        <p class="iwg-regular-value">{{step2.number_of_workers}}</p>
                                    </div>
                                    <div class="iwg-widget-box-card" *ngIf="step1.service_type_id == 1">
                                        <label class="iwg-regular-label">Residence</label>
                                        <p class="iwg-regular-value">{{step2.is_expat ? 'Expat' : 'Local'}}</p>
                                    </div>
                                    <div class="iwg-widget-box-card"
                                         *ngIf="step1.service_type_id == 1 && step2.is_expat == true">
                                        <label class="iwg-regular-label">Country of Citizenship</label>
                                        <p class="iwg-regular-value">{{step2.expat_nationality?.Name}}</p>
                                    </div>
                                    <div class="iwg-widget-box-card"
                                         *ngIf="step1.service_type_id == 1 && step2.is_expat == true">
                                        <label class="iwg-regular-label">Visa / Work Permit Required</label>
                                        <p class="iwg-regular-value">{{step2.is_expat_visa_required ? 'Yes' : 'No'}}</p>
                                    </div>
                                    <div class="iwg-widget-box-card"
                                         *ngIf="step1.service_type_id == 1 && step2.is_expat == true">
                                        <label class="iwg-regular-label">Worker is in Country</label>
                                        <p class="iwg-regular-value">{{step2.is_worker_in_country ? 'Yes' : 'No'}}</p>
                                    </div>
                                </div>
                                <div *ngIf="step1.service_type_id == 1">
                                    <div class="iwg-review-bar" layout="row" layout-align="start center">
                                        <span class="iwg-review-bar-title">Step 3: Nature of Work</span><span
                                            flex></span>
                                        <a (click)="selectedStepIndex = 2" class="iwg-review-bar-edit">Edit</a>
                                    </div>
                                    <div class="iwg-widget-box-card">
                                        <label class="iwg-regular-label">Job Title</label>
                                        <p class="iwg-regular-value">{{step3.job_title}}</p>
                                    </div>
                                    <div class="iwg-widget-box-card" *ngIf="step1.service_type_id == 1">
                                        <label class="iwg-regular-label">Travel Required</label>
                                        <p class="iwg-regular-value">{{step3.is_travel_required | yesNo}}</p>
                                    </div>
                                    <div class="iwg-widget-box-card" *ngIf="step1.service_type_id == 1">
                                        <label class="iwg-regular-label">Job Description</label>
                                        <pre style="font-size: 14px;color: #333;margin: 0;white-space: pre-line;font-family: Lato,Helvetica Neue,sans-serif;">{{step3.job_description}}</pre>
                                    </div>
                                    <div class="iwg-widget-box-card" *ngIf="step1.service_type_id == 1">
                                        <label class="iwg-regular-label">Job Description File</label>
                                        <p class="iwg-regular-value"
                                           style="width:250px; overflow-wrap: break-word;white-space: normal;">
                                            {{step3.job_description_file | blank}}
                                            <button mat-button class="mat-icon-button" [disabled]="this.isLoading"
                                                    *ngIf="step3.job_description_file"
                                                    (click)="downloadJobDescriptionFile()">
                                                <mat-icon>file_download</mat-icon>
                                            </button>
                                        </p>
                                    </div>
                                </div>
                                <div *ngIf="step1.service_type_id == 1">
                                    <div class="iwg-review-bar" layout="row" layout-align="start center">
                                        <span class="iwg-review-bar-title">Step 4: Time and Compensation</span><span
                                            flex></span>
                                        <a (click)="selectedStepIndex = 3" class="iwg-review-bar-edit">Edit</a>
                                    </div>
                                    <div class="iwg-widget-box-card">
                                        <label class="iwg-regular-label">Start Date</label>
                                        <p class="iwg-regular-value">{{step4.start_date | date}}</p>
                                    </div>
                                    <div class="iwg-widget-box-card">
                                        <label class="iwg-regular-label">Typical Weekly Hours</label>
                                        <p class="iwg-regular-value">{{step4.weekly_hours}}</p>
                                    </div>
                                    <div class="iwg-widget-box-card">
                                        <label class="iwg-regular-label">Length of Project</label>
                                        <p class="iwg-regular-value" *ngIf="step4.is_project_length_indefinite">
                                            Indefinite
                                        </p>
                                        <div class="iwg-regular-value" *ngIf="!step4.is_project_length_indefinite">
                                            <p [ngPlural]="step4.project_length_years?step4.project_length_years:'0'">
                                                <ng-template ngPluralCase="0"></ng-template>
                                                <ng-template ngPluralCase="one">1 year</ng-template>
                                                <ng-template ngPluralCase="other">{{step4.project_length_years}} years</ng-template>
                                            </p>
                                            <p [ngPlural]="step4.project_length_years?step4.project_length_years:'0'">
                                                <ng-template ngPluralCase="0"></ng-template>
                                                <ng-template ngPluralCase="one">1 month</ng-template>
                                                <ng-template ngPluralCase="other">{{step4.project_length_years}} months</ng-template>
                                            </p>
                                            <p [ngPlural]="step4.project_length_years?step4.project_length_years:'0'">
                                                <ng-template ngPluralCase="0"></ng-template>
                                                <ng-template ngPluralCase="one">1 weeks</ng-template>
                                                <ng-template ngPluralCase="other">{{step4.project_length_years}} weeks</ng-template>
                                            </p>
                                        </div>
                                    </div>
                                    <div class="iwg-widget-box-card">
                                        <label class="iwg-regular-label">Pay Rate</label>
                                        <p class="iwg-regular-value">{{step4.pay_rate | number}} {{step4.selectedCurrency?.Name}}
                                            / {{step4.selectedPayRateType?.Name}}</p>
                                    </div>
                                    <div class="iwg-widget-box-card">
                                        <label class="iwg-regular-label">Commissions Authorized</label>
                                        <p class="iwg-regular-value">{{step4.is_commission_authorized | yesNo}}</p>
                                    </div>
                                    <div class="iwg-widget-box-card">
                                        <label class="iwg-regular-label">Bonuses Authorized</label>
                                        <p class="iwg-regular-value">{{step4.is_bonus_authorized | yesNo}}</p>
                                    </div>
                                    <div class="iwg-widget-box-card">
                                        <label class="iwg-regular-label">Additional Compensation</label>
                                        <p class="iwg-regular-value">{{step4.other_compensation }}</p>
                                    </div>
                                    <div class="iwg-widget-box-card">
                                        <label class="iwg-regular-label">Additional Notes</label>
                                        <p class="iwg-regular-value">{{step4.client_notes}}</p>
                                    </div>
                                </div>
                            
                        </mat-tab>
                    </mat-tab-group>
                </div>
                <div class="d-flex layout-column flex md-padding w-100" *ngIf="selectedStepIndex < 4"
                     style="overflow-x: auto;">
                     <div class="{{ selectedStepIndex < 1 ? 'display-block' : 'display-none' }}">
                    <app-quote-dialog-map 
                                          [resetFormSubject]="resetFormSubject.asObservable()" [quoteMapCode]="quoteMapCode"></app-quote-dialog-map>
                                        </div>
                    <div class="iwg-quote-dialog-country-guide"
                         *ngIf="(selectedStepIndex >= 1)&& countryGuide?.CountryGuideCategoryViews" flex layout-fill>
                        <div class="iwg-quote-dialog-country-header" layout="column" layout-align="end"
                             [ngStyle]="{'background-image': 'url(' + countryGuide.Country.ImageURL + ')'}">
                            <div class="iwg-quote-dialog-country-name" layout layout-align="none center">
                                {{countryGuide.Country?.Name}}
                            </div>
                        </div>

                        <app-country-guide flex popup-mode="'true'" [countryGuide]="countryGuide" layout="column"
                                           alltext="'Please Select'"
                                           layout-fill></app-country-guide>
                    </div>
                </div>
            </div>
        </div>
        <mat-dialog-actions align="end" class="justify-fend" style="width: 45%;">

            <div fxLayout="row" fxLayoutAlign="space-between center" style="overflow:auto;">
               <div class="vista-action-btnback">
                    <button class="back-btn-vista" mat-button [disabled]="isFileUploadInProgress"
                            *ngIf="selectedStepIndex != 0" (click)="prevStep()">« Back
                    </button>
                </div>

                <div class="vista-action-btn">
                    <button mat-button [disabled]="isFileUploadInProgress" *ngIf="selectedStepIndex == 0"
                            (click)="cancel()">Cancel
                    </button>
                </div>
               
                <div class="vista-action-btn">
                    <button mat-button class="vista-dialogbtn" *ngIf="selectedStepIndex != 4" (click)="nextStep()">
                        Save &
                        Continue
                    </button>
                </div>

                <div class="vista-action-btn">
                    <button mat-button [disabled]="isFileUploadInProgress"
                            *ngIf="selectedStepIndex != 5 && selectedStepIndex != 0" (click)="saveAsDraft()">Save As
                        Draft
                    </button>
                </div>

                <div class="vista-action-btn">
                    <button mat-button mat-dialog-close class="vista-dialogbtn" *ngIf="selectedStepIndex == 4"
                            (click)="submit()">Submit
                    </button>
                </div>

            </div>
        </mat-dialog-actions>
    </mat-dialog-content>
</div>
